import type { Config } from './config';

export async function getCacheMetadata({ cacheMetadataKey, storageInterface }: Config) {
  const metadata = await storageInterface.getItem(cacheMetadataKey);

  const jsonMetadata: { version?: number } = JSON.parse(metadata || '{}');

  return jsonMetadata;
}

export async function setCacheMetadata(config: Config) {
  await config.storageInterface.setItem(config.cacheMetadataKey, JSON.stringify({ version: config.version }));
}
